import Button from "../../../../components/Buttons/Button";

const Agreement = ({ onHandleAgree }) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-10 px-4 pt-10 pb-4 top-10">
      <div className="flex flex-col justify-center gap-5 px-6 items-center w-full h-full bg-neutral-100 bg-opacity-95 rounded-[20px] text-center">
        <p className="py-2 px-8 bg-neutral-600 rounded-[50px] text-white text-sm font-semibold">
          상품 정보 조회 매장 방문시 주의사항
        </p>
        <p className="px-5 text-xl font-semibold break-keep">
          점포별 영업 상황에 따라 가격 및 재고 수량이 다소 차이가 날 수 있으니
          양해 부탁드립니다.
        </p>
        <p className="text-sm font-medium text-neutral-500 ">
          전산 재고와 실재고 차이 보상은 <br /> 지급되지 않습니다.
        </p>
        <Button onClick={() => onHandleAgree(true)}>동의 후 조회</Button>
      </div>
    </div>
  );
};

export default Agreement;
